var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNakricom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.468,
    height: 24,
    viewBox: "0 0 86.468 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49977",
    "data-name": "Group 49977",
    transform: "translate(-136.13 -30.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93890",
    "data-name": "Path 93890",
    d: "M172.749,36.768a4.108,4.108,0,0,0-1.773.381,3.572,3.572,0,0,0-1.327,1.048v-1.28h-2.6V47.2h2.6V41.52a2.638,2.638,0,0,1,.622-1.884,2.223,2.223,0,0,1,1.7-.66,2.167,2.167,0,0,1,1.67.66,2.664,2.664,0,0,1,.613,1.884V47.2h2.6V41.166a4.44,4.44,0,0,0-1.133-3.238A3.963,3.963,0,0,0,172.749,36.768Z",
    fill: "#265df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93891",
    "data-name": "Path 93891",
    d: "M186.4,38.384a4.078,4.078,0,0,0-1.381-1.169A4.2,4.2,0,0,0,183,36.75a4.492,4.492,0,0,0-2.385.65,4.552,4.552,0,0,0-1.69,1.856,5.959,5.959,0,0,0-.621,2.763,6.053,6.053,0,0,0,.621,2.794,4.67,4.67,0,0,0,1.69,1.884,4.368,4.368,0,0,0,2.366.668,4.222,4.222,0,0,0,2.032-.473,3.848,3.848,0,0,0,1.381-1.2v1.5h2.618V36.918H186.4Zm-.371,5.3a2.626,2.626,0,0,1-1,1.036,2.68,2.68,0,0,1-1.355.362,2.541,2.541,0,0,1-1.327-.371,2.748,2.748,0,0,1-1-1.067,3.339,3.339,0,0,1-.38-1.625,3.233,3.233,0,0,1,.38-1.6,2.677,2.677,0,0,1,3.685-1.021,2.627,2.627,0,0,1,1,1.036,3.327,3.327,0,0,1,.371,1.624A3.373,3.373,0,0,1,186.027,43.684Z",
    fill: "#265df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93892",
    "data-name": "Path 93892",
    d: "M197.847,42.583a2.667,2.667,0,0,1-.613,1.884,2.2,2.2,0,0,1-1.689.659,2.169,2.169,0,0,1-1.67-.659,2.667,2.667,0,0,1-.613-1.884V36.918h-2.6v6.036a4.971,4.971,0,0,0,.529,2.366,3.6,3.6,0,0,0,1.458,1.5,4.351,4.351,0,0,0,2.134.51,4.057,4.057,0,0,0,1.754-.381,3.429,3.429,0,0,0,1.309-1.049v1.3h2.616V36.921h-2.616Z",
    fill: "#265df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93893",
    "data-name": "Path 93893",
    d: "M211.539,36.925H208.16l-3.452,4.362V33.473h-2.6V47.208h2.6v-4.38l3.489,4.38h3.378l-4.565-5.123Z",
    fill: "#265df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93894",
    "data-name": "Path 93894",
    d: "M215.375,38.519v-1.6h-2.6V47.2h2.6V42.079a2.167,2.167,0,0,1,2.469-2.58h.691V36.771a3.574,3.574,0,0,0-3.158,1.748Z",
    fill: "#265df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93895",
    "data-name": "Path 93895",
    d: "M222.345,36.918h-2.6V47.205h2.6Z",
    fill: "#265df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93896",
    "data-name": "Path 93896",
    d: "M221.044,35.69a1.554,1.554,0,1,0-1.553-1.554A1.553,1.553,0,0,0,221.044,35.69Z",
    fill: "#265df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93897",
    "data-name": "Path 93897",
    d: "M148.13,54.06a12,12,0,1,0-12-12A12,12,0,0,0,148.13,54.06Z",
    fill: "#265df5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93898",
    "data-name": "Path 93898",
    d: "M151.738,46.5l-.027,1.216-.077,3.512v.135c-5.935-5.136-6.946-6.389-7.121-6.769l-.006-.013a.516.516,0,0,1-.015-.221.569.569,0,0,1,.018-.081c.006-.021.012-.042.019-.065a1.669,1.669,0,0,1,.269-.464,2.727,2.727,0,0,1,.266-.3,5.9,5.9,0,0,1,.654-.559c.115-.086.235-.173.362-.259.245-.167.51-.335.785-.5C149,44.131,151.7,46.472,151.738,46.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93899",
    "data-name": "Path 93899",
    d: "M151.817,34.969l-.027,1.221-.014.6-.027,1.215-.014.61-.027,1.215a38.074,38.074,0,0,0-4.834,2.308c-.275.163-.539.331-.785.5q-.189.129-.362.259a5.982,5.982,0,0,0-.654.558,3,3,0,0,0-.266.3,1.341,1.341,0,0,0-.318.7l.023-1.014v-.007l0-.157v-.057l.018-.64.035-1.268.016-.62.035-1.257C145.049,37.673,151.108,35.248,151.817,34.969Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93900",
    "data-name": "Path 93900",
    d: "M146.23,36.313a1.781,1.781,0,1,0-1.781-1.781A1.781,1.781,0,0,0,146.23,36.313Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNakricom);
export default __webpack_public_path__ + "static/media/nakricom.2adb84cc2b698d965e9727fa33d32779.svg";
export { ForwardRef as ReactComponent };